export default __webpack_public_path__ + "static/media/plate4.ef559681.png";